var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ecOdACBf28H1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 556",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ecOdACBf28H2",
    d: "M1087.69841,180.46811c19.29064,19.17793,31.23301,45.73926,31.23301,75.08989c0,58.4767-47.40473,105.88143-105.88143,105.88143s-105.88143-47.40473-105.88143-105.88143h.00001c0-58.4767,47.40473-105.88143,105.88143-105.88143.40052,0,.80053.00222,1.2.00666",
    transform: "translate(-646.99999 0)",
    fill: "none",
    stroke: "#9dc6c6",
    strokeWidth: 35,
    strokeDashoffset: 583.707435,
    strokeDasharray: 583.707435
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-647-.000001)",
    clipPath: "url(#ecOdACBf28H8)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M823.959,499.699l46.608,44.203l45.004-46.264",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 17,
    strokeDashoffset: 128.77796,
    strokeDasharray: 128.77796
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ecOdACBf28H6",
    r: 31.3985,
    transform: "translate(1013.05 52.2466)",
    fill: "none",
    stroke: "#004645",
    strokeWidth: 15,
    strokeDashoffset: 197.28,
    strokeDasharray: 197.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "ecOdACBf28H7",
    d: "M744.478,118.246h172.168v72.033",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 28,
    strokeDashoffset: 244.201,
    strokeDasharray: 244.201
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ecOdACBf28H8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1145,
    height: 556,
    rx: 0,
    ry: 0,
    transform: "translate(.893799 0)",
    fill: "#fff"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ecOdACBf28H10",
    d: "M823.959,500.147999l46.75,43.754l44.862-46.264",
    transform: "translate(-647 0)",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 15,
    strokeDashoffset: 128.474486,
    strokeDasharray: 128.474486
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroRight);
export default __webpack_public_path__ + "static/media/hero-right.0cf4d96308d38f0dbd81c5cbbfa272f4.svg";
export { ForwardRef as ReactComponent };